import React from 'react';
import {
  Box,
  AppBar,
  Toolbar,
  Button,
  Chip,
  CircularProgress,
} from '@mui/material';
import {
  Save,
  Visibility,
  ArrowBack,
  CheckCircle,
  ContentCopy,
} from '@mui/icons-material';

interface PhaseNavigationToolbarProps {
  onSave: () => void;
  onPreview: () => void;
  onBack: () => void;
  hasUnsavedChanges: boolean;
  isSaving: boolean;
  isSaved?: boolean;
  onSaveAsTemplate?: () => void;
}

const PhaseNavigationToolbar: React.FC<PhaseNavigationToolbarProps> = ({
  onSave,
  onPreview,
  onBack,
  hasUnsavedChanges,
  isSaving,
  isSaved = false,
  onSaveAsTemplate,
}) => {
  return (
    <AppBar 
      position="sticky" 
      sx={{ 
        top: 64, // Below main AppBar
        backgroundColor: '#f5f5f5',
        color: '#000',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        zIndex: 1100,
      }}
    >
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Button
            startIcon={<ArrowBack />}
            onClick={onBack}
            color="inherit"
            variant="outlined"
          >
            Back to Dashboard
          </Button>
          
          {hasUnsavedChanges && (
            <Chip
              label="Unsaved Changes"
              color="warning"
              size="small"
              sx={{ ml: 1 }}
            />
          )}
          
          {isSaved && !hasUnsavedChanges && (
            <Chip
              icon={<CheckCircle />}
              label="Saved"
              color="success"
              size="small"
              sx={{ ml: 1 }}
            />
          )}
        </Box>

        <Box sx={{ display: 'flex', gap: 2 }}>
          {onSaveAsTemplate && (
            <Button
              variant="outlined"
              startIcon={<ContentCopy />}
              onClick={onSaveAsTemplate}
              color="inherit"
            >
              Save as Template
            </Button>
          )}
          <Button
            variant="outlined"
            startIcon={<Visibility />}
            onClick={onPreview}
            color="inherit"
          >
            Preview
          </Button>
          
          <Button
            variant="contained"
            startIcon={isSaving ? <CircularProgress size={16} /> : <Save />}
            onClick={onSave}
            disabled={!hasUnsavedChanges || isSaving}
            color="primary"
          >
            {isSaving ? 'Saving...' : 'Save'}
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default PhaseNavigationToolbar;

